import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

import { MENU_ITEM_NAMES } from 'styles/constants/appearanceSectionNames';
import { TITLE_BY_FULFILLMENT_METHOD } from 'constants/fulfillmentOptions';
import { GROUP_ORDER_CART_HEADER_TITLE } from 'bento-ordering/group_ordering/constants/groupOrder';

const titleByFulfillmentMethodStyle = ({ theme, hasAction }) => {
  const styles = {
    color: theme.palette.sectionNav.link.main,
    borderBottom: `2px solid ${theme.palette.header.accent.main}`,
    paddingBottom: 6,
    lineHeight: 1.25,
    fontSize: 20,
    cursor: hasAction ? 'pointer' : 'inherit',
    '&:hover': {
      color: hasAction ? theme.palette.secondary.main : 'inherit'
    }
  };
  return {
    borderBottom: `2px solid ${theme.palette.secondary.main}`,
    ...styles
  };
};

const StyledLink = styled(Link)(titleByFulfillmentMethodStyle);
const StyledTypography = styled(Typography)(titleByFulfillmentMethodStyle);
const StyledHeaderText = styled(Typography)(({ theme }) => {
  return {
    color: theme.palette.sectionNav.link.main,
    fontSize: 20,
    lineHeight: 1.25
  };
});

function CartHeader({
  fulfillmentMethod,
  onClick,
  isGroupOrder = false,
  groupOrderAdminName = ''
}) {
  const hasAction = !!onClick;
  const styles = { variant: MENU_ITEM_NAMES };

  return (
    <Box mb={1} display="flex">
      {isGroupOrder ? (
        <StyledHeaderText {...styles}>
          {`${groupOrderAdminName}${GROUP_ORDER_CART_HEADER_TITLE}`}
        </StyledHeaderText>
      ) : (
        <>
          <StyledHeaderText {...styles}>Your&nbsp;</StyledHeaderText>
          {hasAction && (
            <StyledLink
              hasAction
              component="button"
              onClick={onClick}
              underline="none"
              {...styles}
            >
              {TITLE_BY_FULFILLMENT_METHOD[fulfillmentMethod]}
            </StyledLink>
          )}
          {!hasAction && (
            <StyledTypography
              hasAction={hasAction}
              underline="none"
              {...styles}
            >
              {TITLE_BY_FULFILLMENT_METHOD[fulfillmentMethod]}
            </StyledTypography>
          )}
          <StyledHeaderText {...styles}>&nbsp;Order</StyledHeaderText>
        </>
      )}
    </Box>
  );
}

CartHeader.propTypes = {
  fulfillmentMethod: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isGroupOrder: PropTypes.bool,
  groupOrderAdminName: PropTypes.string
};

CartHeader.defaultProps = {
  onClick: null
};

export default CartHeader;
